import type { Pronoun } from '@/api/types';

export const DEFAULT_VERB = 'ser';

// Frequently used verbs, offered as buttons above the table
export const PREPARED_VERBS: readonly string[] = [
    'ser', 'estar', 'hacer', 'tener', 'ir', 'querer', 'decir', 'ver', 'oir', 'saber',
    'viajar', 'comer', 'beber', 'salir', 'poder', 'poner', 'empezar', 'comenzar', 'nadar',
    'decidir', 'lavar', 'vivir', 'acabar', 'volver', 'dejar', 'deber', 'acostumbrar',
    'acostumbrarse', 'gustar', 'andar', 'caber', 'dar', 'traer', 'venir', 'haber',
].toSorted();

// Pronouns in the order of the table rows, with their labels
export const PRONOUNS: readonly (readonly [Pronoun, string])[] = [
    ['yo', 'Yo'],
    ['tu', 'Tu'],
    ['vos', 'Vos'],
    ['el_ella_usted', 'El/Ella/Usted'],
    ['nosotros', 'Nosotros'],
    ['vosotros', 'Vosotros'],
    ['ustedes', 'Ellos/Ustedes'],
];

// The backend looks verbs up case-sensitively and scrapes any verb it doesn't find
export const normalizeVerb = (input: string) => input.trim().toLowerCase();
